import { useEffect } from 'react';

const SITE_URL = 'https://xceedagents.ai';
const DEFAULT_TITLE = "XceedAgents.ai | Tell us what you need done. We'll build the agent.";
const DEFAULT_DESC = "XceedAgents.ai builds AI agents that automate your business — WhatsApp bots, dashboards, ERP/CRM agents, websites, and full products. Tell us what you need done, we'll build the agent.";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

function setMeta({ name, property, content }) {
  if (!content) return;
  const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    if (name) el.setAttribute('name', name);
    if (property) el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function setStructuredData(id, data) {
  // Remove old script with same id
  const old = document.getElementById(id);
  if (old) old.remove();
  if (!data) return;
  const s = document.createElement('script');
  s.type = 'application/ld+json';
  s.id = id;
  s.textContent = JSON.stringify(data);
  document.head.appendChild(s);
}

/**
 * SEO component using DOM mutations for clean head management.
 * Avoids React 19's duplicate-title hoisting issue.
 */
export default function SEO({ title, description, path, image, type = 'website', structuredData }) {
  useEffect(() => {
    const finalTitle = title ? `${title} | XceedAgents.ai` : DEFAULT_TITLE;
    const finalDesc = description || DEFAULT_DESC;
    const pathSegment = path !== undefined ? path : window.location.pathname;
    const canonical = `${SITE_URL}${pathSegment}`;
    const finalImage = image || DEFAULT_IMAGE;

    document.title = finalTitle;
    setMeta({ name: 'description', content: finalDesc });
    setLink('canonical', canonical);

    setMeta({ property: 'og:type', content: type });
    setMeta({ property: 'og:title', content: finalTitle });
    setMeta({ property: 'og:description', content: finalDesc });
    setMeta({ property: 'og:url', content: canonical });
    setMeta({ property: 'og:image', content: finalImage });

    setMeta({ name: 'twitter:card', content: 'summary_large_image' });
    setMeta({ name: 'twitter:title', content: finalTitle });
    setMeta({ name: 'twitter:description', content: finalDesc });
    setMeta({ name: 'twitter:image', content: finalImage });

    setStructuredData('seo-structured-data', structuredData);
  }, [title, description, path, image, type, structuredData]);

  return null;
}
